// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Wh-z","trustedRetailerTooltipWrapper":"Xh-z"};